import state from 'shared/helpers/vuex/result/state'

export default {
    ...state
}


// WEBPACK FOOTER //
// ./src/residential/modules/Result/vuex/state.js